import { render, staticRenderFns } from "./buildLogin.vue?vue&type=template&id=5eddbfd9&scoped=true"
import script from "./buildLogin.vue?vue&type=script&lang=js"
export * from "./buildLogin.vue?vue&type=script&lang=js"
import style0 from "./buildLogin.vue?vue&type=style&index=0&id=5eddbfd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eddbfd9",
  null
  
)

export default component.exports